import { graphql, useStaticQuery } from "gatsby";
import { useCallback } from "react";
import { find, isEmpty } from "lodash";

import { useTranslationContext } from "~/context/TranslationContext";

const useGetBasePath = (onlyEnglishPaths = false) => {
    const { allWpTranslatableOptions } = useStaticQuery(graphql`
        query StaticGetBasePathQuery {
            allWpTranslatableOptions {
                nodes {
                    languageCode
                    translatableOptionFields {
                        basePathUrls {
                            identifier
                            label
                            url
                        }
                    }
                }
            }
        }
    `);

    const { activeCode } = useTranslationContext();

    const english = find(allWpTranslatableOptions?.nodes, {
        languageCode: "en",
    });

    const translation = find(allWpTranslatableOptions?.nodes, {
        languageCode: activeCode,
    });

    const enPaths = english?.translatableOptionFields?.basePathUrls;
    const trPaths = translation?.translatableOptionFields?.basePathUrls;

    return useCallback(
        (identifier) => {
            const basePaths =
                isEmpty(trPaths) || onlyEnglishPaths ? enPaths : trPaths;
            return find(basePaths, { identifier });
        },
        [enPaths, trPaths, onlyEnglishPaths],
    );
};

export default useGetBasePath;
